import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/** Piezas de formulario compartidas por la calculadora 3D. */

export const claseInput =
  'w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 ' +
  'text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent';

export const Bloque: React.FC<{
  n?: string;
  titulo: string;
  subtitulo?: string;
  abiertoPorDefecto?: boolean;
  children: React.ReactNode;
}> = ({ n, titulo, subtitulo, abiertoPorDefecto = false, children }) => {
  const [abierto, setAbierto] = useState(abiertoPorDefecto);
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 mb-3 overflow-hidden">
      <button type="button" onClick={() => setAbierto(v => !v)} aria-expanded={abierto}
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 dark:hover:bg-gray-700/50 transition">
        {n && <span className="font-mono text-xs text-gray-400 dark:text-gray-500 w-5 shrink-0">{n}</span>}
        <span className="font-semibold text-gray-900 dark:text-white text-sm">{titulo}</span>
        {subtitulo && (
          <span className="hidden sm:block text-xs text-gray-500 dark:text-gray-400 flex-1">{subtitulo}</span>
        )}
        <ChevronDown className={`w-4 h-4 text-gray-400 shrink-0 ml-auto sm:ml-0 transition-transform ${abierto ? 'rotate-180' : ''}`} />
      </button>
      {abierto && (
        <div className="px-4 pb-4 pt-1 border-t border-gray-100 dark:border-gray-700">{children}</div>
      )}
    </div>
  );
};

export const Campo: React.FC<{
  label: string; ayuda?: string; children: React.ReactNode;
}> = ({ label, ayuda, children }) => (
  <div className="flex flex-col gap-1 min-w-0">
    <label className="text-xs font-semibold text-gray-600 dark:text-gray-400">{label}</label>
    {children}
    {ayuda && <p className="text-[11px] leading-snug text-gray-500 dark:text-gray-500">{ayuda}</p>}
  </div>
);

export const NumInput: React.FC<{
  valor: number; onChange: (v: number) => void; unidad?: string;
  min?: number; max?: number; step?: number; placeholder?: string;
}> = ({ valor, onChange, unidad, min = 0, max, step = 1, placeholder }) => (
  <div className="relative">
    <input type="number" inputMode="decimal" value={Number.isFinite(valor) ? valor : 0}
      min={min} max={max} step={step} placeholder={placeholder}
      onChange={e => onChange(e.target.value === '' ? 0 : parseFloat(e.target.value))}
      className={`${claseInput} font-mono ${unidad ? 'pr-16' : ''}`} />
    {unidad && (
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[11px] font-mono text-gray-400 pointer-events-none">
        {unidad}
      </span>
    )}
  </div>
);

export const Segmentado: React.FC<{
  opciones: { valor: string; label: string }[];
  valor: string; onChange: (v: string) => void;
}> = ({ opciones, valor, onChange }) => (
  <div className="flex rounded-lg border border-gray-300 dark:border-gray-600 overflow-hidden">
    {opciones.map(o => (
      <button key={o.valor} type="button" onClick={() => onChange(o.valor)}
        aria-pressed={valor === o.valor}
        className={`flex-1 px-3 py-2 text-sm font-semibold transition ${
          valor === o.valor
            ? 'bg-gray-900 dark:bg-orange-600 text-white'
            : 'bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
        }`}>
        {o.label}
      </button>
    ))}
  </div>
);
